import React from "react";
import { Helmet } from "react-helmet";

// custom css
import "./home.css";
// quick buttons
import "../QuickAccess/quick.css";
import auth from "../../providers/Auth.Provider";
import { AppName } from "../../util/app";
import { NavLink } from "react-router-dom";

function Home() {
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;

    const { admin, site } = GetToken() && GetAuthenticatedStaff();

    return (
        <>
            {" "}
            <Helmet>
                <title>Administrator | {AppName}</title>
            </Helmet>
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            Active Site: <strong className="text-success">{site.name}</strong> - {site.type.name}
                            <hr />
                        </div>
                    </div>
                    <h4>
                        <i className="fa fa-bars"></i> Navigation
                    </h4>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="row justify-content-center">
                                {admin && (
                                    <>
                                        <div className="col-lg-2 col-md-3 col-4">
                                            <NavLink to="/home/staffing/dashboard">
                                                <div className="quick-action-container">
                                                    <i className="material-icons quick-icon text-pink">group</i>
                                                    <span className="quick-text">Staffing</span>
                                                </div>
                                            </NavLink>
                                        </div>
                                        <div className="col-lg-2 col-md-3 col-4">
                                            <NavLink to="/home/rota">
                                                <div className="quick-action-container">
                                                    <i className="material-icons quick-icon text-black">work</i>
                                                    <span className="quick-text">Rota</span>
                                                </div>
                                            </NavLink>
                                        </div>
                                    </>
                                )}

                                {admin && (
                                    <>
                                        <div className="col-lg-2 col-md-3 col-4">
                                            <NavLink to="/home/app-management">
                                                <div className="quick-action-container">
                                                    <i className="material-icons quick-icon text-blue">verified_user</i>
                                                    <span className="quick-text">Management</span>
                                                </div>
                                            </NavLink>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
